import React from 'react';
import Icon from '../../../components/AppIcon';

const ProfileAnalyticsCards = ({ stats, loading }) => {
  if (loading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
        {[1, 2, 3, 4]?.map((i) => (
          <div key={i} className="bg-card rounded-xl border border-border p-6 animate-pulse">
            <div className="h-12 bg-muted rounded mb-3"></div>
            <div className="h-8 bg-muted rounded mb-2"></div>
            <div className="h-4 bg-muted rounded"></div>
          </div>
        ))}
      </div>
    );
  }

  const analyticsCards = [
    {
      id: 'profile-views',
      icon: 'Eye',
      value: stats?.totalViews || 0,
      label: 'Profile Views',
      description: 'Total profile visitors',
      color: 'primary',
      gradient: 'from-primary/10 to-primary/5'
    },
    {
      id: 'scout-views',
      icon: 'Users',
      value: stats?.scoutViews || 0,
      label: 'Scout Views',
      description: 'Professional scouts interested',
      color: 'success',
      gradient: 'from-success/10 to-success/5'
    },
    {
      id: 'club-views',
      icon: 'Building',
      value: stats?.clubViews || 0,
      label: 'Club Views',
      description: 'Clubs checking your profile',
      color: 'accent',
      gradient: 'from-accent/10 to-accent/5'
    },
    {
      id: 'agent-views',
      icon: 'Briefcase',
      value: stats?.agentViews || 0,
      label: 'Agent Views',
      description: 'Licensed agents interested',
      color: 'warning',
      gradient: 'from-warning/10 to-warning/5'
    },
    {
      id: 'active-club-interest',
      icon: 'Heart',
      value: stats?.activeClubInterest || 0,
      label: 'Active Club Interest',
      description: 'Clubs actively tracking you',
      color: 'secondary',
      gradient: 'from-secondary/10 to-secondary/5'
    },
    {
      id: 'scout-feedback',
      icon: 'Star',
      value: stats?.totalScoutFeedback || 0,
      label: 'Scout Feedback',
      description: 'Total scout reviews received',
      color: 'primary',
      gradient: 'from-primary/10 to-primary/5'
    },
    {
      id: 'weekly-views',
      icon: 'TrendingUp',
      value: stats?.viewsLast7Days || 0,
      label: 'Weekly Views',
      description: 'Profile views last 7 days',
      color: 'success',
      gradient: 'from-success/10 to-success/5'
    },
    {
      id: 'monthly-views',
      icon: 'Activity',
      value: stats?.viewsLast30Days || 0,
      label: 'Monthly Views',
      description: 'Profile views last 30 days',
      color: 'accent',
      gradient: 'from-accent/10 to-accent/5'
    }
  ];

  const getColorClasses = (color) => {
    const colors = {
      primary: 'text-primary bg-primary/10',
      secondary: 'text-secondary bg-secondary/10',
      success: 'text-success bg-success/10',
      accent: 'text-accent bg-accent/10',
      warning: 'text-warning bg-warning/10'
    };
    return colors?.[color] || colors?.primary;
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
      {analyticsCards?.map((card) => (
        <div
          key={card?.id}
          className={`bg-gradient-to-br ${card?.gradient} rounded-xl border border-border p-6 hover:shadow-lg transition-all duration-300 hover:scale-105 group`}
        >
          <div className="flex items-start justify-between mb-4">
            <div className={`w-12 h-12 rounded-lg ${getColorClasses(card?.color)} flex items-center justify-center group-hover:scale-110 transition-transform duration-300`}>
              <Icon name={card?.icon} size={24} />
            </div>
          </div>
          <div className="space-y-1">
            <p className="text-3xl font-bold text-foreground font-headline">{card?.value}</p>
            <p className="text-base font-semibold text-foreground">{card?.label}</p>
            <p className="text-sm text-muted-foreground">{card?.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProfileAnalyticsCards;